import { user, userActionType,SAVE_USER } from './types';

export function SaveUser(user: user): userActionType {
  return {
    type: SAVE_USER,
    payload: user,
  };
}
